import ecLogo from "../img/logoEC_azul.svg"

type FooterType = {
  year: number
}

export default function Footer({ year }: FooterType) {
  return (
    <footer
      className="px-3 py-2 bg-white flex justify-between items-center"
    // style={{ boxShadow: "0 -5px 5px -5px #aaa" }}
    >
      <a href="https://www.envioclick.com">
        <img className="h-4" src={ecLogo} alt="Envíoclick" />
      </a>
      <span className="text-xs">{year} Envíoclick® Derechos reservados</span>
    </footer>
  )
}